// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2vDI6","right":"styles_right__2chW_"};